"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SMALL = exports.LARGE = exports.BACKDROP_Z_INDEX = exports.BACKDROP_OPACITY = void 0;
const BACKDROP_OPACITY = exports.BACKDROP_OPACITY = 0.06;
const BACKDROP_Z_INDEX = exports.BACKDROP_Z_INDEX = 1400;
const LARGE = exports.LARGE = 'large';
const SMALL = exports.SMALL = 'small';